import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { AuditLogOptionsController_facets } from '@/services/services';

import { mapAuditLogFacets } from './mappers';
import type { UseAuditFacetsResult } from './types';

const AUDIT_FACETS_KEY = 'auditLogFacets';

/** New actions appear only when someone first performs them, so minutes of staleness are fine. */
const FACETS_STALE_MS = 5 * 60 * 1000;

/** The actions and entity types recorded so far, for the Action and Target type pickers. */
export function useAuditFacets(): UseAuditFacetsResult {
    const query = useQuery({
        queryKey: [AUDIT_FACETS_KEY],
        queryFn: async () => (await AuditLogOptionsController_facets()).data,
        staleTime: FACETS_STALE_MS,
        refetchOnWindowFocus: false,
    });
    const facets = useMemo(() => mapAuditLogFacets(query.data), [query.data]);
    return { facets, isLoading: query.isPending, error: query.error };
}
